var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.059,
    height: 24.235,
    viewBox: "0 0 15.059 24.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_211854_location_icon",
    "data-name": "211854_location_icon",
    transform: "translate(-136.7 -64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M144.229,64a7.55,7.55,0,0,0-7.529,7.573c0,7.233,7.529,16.661,7.529,16.661s7.529-9.429,7.529-16.661A7.55,7.55,0,0,0,144.229,64Zm0,11.246a3.582,3.582,0,1,1,3.559-3.578A3.568,3.568,0,0,1,144.229,75.246Z",
    transform: "translate(0)",
    fill: "#0f43cc"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a180957b7abe729059758074a0eeea68.svg";
export { ForwardRef as ReactComponent };